export default __webpack_public_path__ + "6dd20bdc0c1181c9a7e960c6f2daecfc.mp3";